module.exports = __webpack_public_path__ + "img/banner-task.e2c2fed5.png";